import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {Example} from '../../models/example.model';

@Component({
  selector: 'app-example-list-item',
  templateUrl: './example-list-item.component.html',
  styleUrls: ['./example-list-item.component.scss'],
})
export class ExampleListItemComponent {
  @HostBinding('style.display') styleBlock = 'block';
  @Input() example?: Example;
  @Input() manualPlay = false;
  @Output() play = new EventEmitter<MouseEvent>();
}
